import { useEffect, useState } from 'react'
import authService from '../../../components/api-authorization/AuthorizeService'

export const useCurrentUserInformation = () => {
    const [userInformation, setUserInformation] = useState<any>(undefined)

    useEffect(() => {
        const handle = async () => {
            try {
                const userInformation = await authService.getUser()
                setUserInformation(userInformation)
            } catch (e) {
                console.log(e)
            }      
        }

        handle()
    }, [])

    return {
        userInformation
    }
}